import { render, staticRenderFns } from "./AppCard.vue?vue&type=template&id=f42d309e"
import script from "./AppCard.vue?vue&type=script&lang=js"
export * from "./AppCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports